import { render, staticRenderFns } from "./zhengxin.vue?vue&type=template&id=49f78b72&scoped=true"
import script from "./zhengxin.vue?vue&type=script&lang=js"
export * from "./zhengxin.vue?vue&type=script&lang=js"
import style0 from "./zhengxin.vue?vue&type=style&index=0&id=49f78b72&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f78b72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/check/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49f78b72')) {
      api.createRecord('49f78b72', component.options)
    } else {
      api.reload('49f78b72', component.options)
    }
    module.hot.accept("./zhengxin.vue?vue&type=template&id=49f78b72&scoped=true", function () {
      api.rerender('49f78b72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/zhengxin.vue"
export default component.exports